import { createI18n } from "vue-i18n";
import uz from "./locales/uz.json";
import ru from "./locales/ru.json";

const messages = { uz, ru };
const savedLanguage = localStorage.getItem("language") || "uz";

const i18n = createI18n({
  legacy: false,
  locale: savedLanguage,
  messages,
});

export default i18n;
